module.exports = __webpack_public_path__ + "0eacd879aac923f92c97c8177050e632.svg";